"use strict";
const R = require('ramda');
const apConfig = require('./ap');
const productionConfig = require('./production');
module.exports = R.pipe(R.mergeDeepLeft(productionConfig))(apConfig);
